import Head from 'next/head';
import { DefaultSeo } from 'next-seo';

export default function StructuredData() {
  return (
    <>
      <DefaultSeo
      // Define default SEO configuration here
      />
      <Head>
        <title>
          eighteen yards | sports digital marketing strategy 
        </title>
        <meta
          name="description"
          content="Unleash your digital potential with our Sports Digital Marketing Strategies. Tailored solutions to outperform your competition. Contact us today."
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "url": "https://eighteenyards.com/services",
              "name": "eighteen yards | sports digital marketing services",
              "description": "Explore our comprehensive range of sports digital marketing services at eighteen yards. We specialise in digital strategy, performance marketing, training, and data analytics to elevate your brand's online presence.",
              "mainEntity": {
                "@type": "Service",
                "serviceType": "Sports Digital Marketing Services",
                "provider": {
                  "@type": "Organization",
                  "name": "eighteen yards",
                  "url": "https://eighteenyards.com"
                },
                "description": "Explore our comprehensive range of sports digital marketing services at eighteen yards. We specialise in digital strategy, performance marketing, training, and data analytics to elevate your brand's online presence.",
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": "Sports Digital Marketing Services",
                  "itemListElement": [
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Strategy",
                        "description": "Strategy is the foundation of success in the digital landscape. With our comprehensive audience planning, industry research, and competitor analysis, we gather the insights needed to create a roadmap for your success. By combining our deep understanding of your business with data-driven strategies, we develop a digital strategy that aligns with your objectives and sets you apart from the competition."
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Performance",
                        "description": "Our performance marketing solutions actively incorporate search engine optimization (SEO), paid social media advertising, and Google Ads to enhance your brand's visibility, reach your target audience effectively, and generate significant conversions. By leveraging data-driven insights and implementing strategic optimizations, we work hard to ensure that your return on investment is maximised, assisting you in outperforming your competition."
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Data & Analytics",
                        "description": "Our data and analytics services centre around harnessing the power of cutting-edge tools like Google Analytics, Google Tag Manager, and Google Looker Studio. We'll assist you in implementing, configuring, and leveraging these tools to meticulously track and measure key metrics, gain actionable insights, and optimise your digital marketing efforts for maximum impact."
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Training",
                        "description": "We help businesses unlock their full potential in sports digital marketing. Our bespoke trainings are built to equip your team with the knowledge and skills necessary to excel in the digital landscape. Whether it's social media marketing, search engine optimization (SEO), or Google Analytics 4, our training sessions offer practical insights and skills. Your team will gain the expertise needed to navigate and succeed in the ever-evolving world of sports digital marketing."
                      }
                    }
                  ]
                }
              }
            }),
          }}
        />
      </Head>
    </>
  )
}
